import { Typography } from '@material-ui/core'
import React from 'react'
import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'

function PlanPhysicalWebStarterPackInfo(props) {
  const { plan = {}, className } = props
  return (
    <div className={clsx(className, 'flex flex-col')}>
      <Typography>
        <FormattedMessage id="planAndBilling.yourPlan.changePlan.plan.starterPack.info.twoBeacons" />
      </Typography>
      <Typography>
        <FormattedMessage
          id="planAndBilling.yourPlan.changePlan.plan.starterPack.info.notificationNumbers"
          values={{
            notificationNumbers: plan.notesQuantity,
          }}
        />
      </Typography>
      <Typography>
        <FormattedMessage id="planAndBilling.yourPlan.changePlan.plan.starterPack.info.shipping" />
      </Typography>
      <Typography>
        <FormattedMessage id="planAndBilling.yourPlan.changePlan.plan.starterPack.info.setupAndMaintenance" />
      </Typography>
      <Typography>
        <FormattedMessage id="planAndBilling.yourPlan.changePlan.plan.starterPack.info.support" />
      </Typography>
    </div>
  )
}

export default PlanPhysicalWebStarterPackInfo
